/*
 *  Product Thumbnail Print
 *    Exporting common product thumbnail string.
 *
 *
 *  Version:
 *    1.0.0 - 2019/06/17
 */
import { generatePicture, printMoney, escapeString, handlize, generateIcon, getImageUrl, getCountOfVariantInCart
} from './../../process/pc-slate-tools';
import { generatePricing } from '../pricing/ProductPricing';

export const CP = 'o-product-thumbnail';

export const ProductThumbnailPrint = (p, p2, url, discounted, saving, available, compare, v) => {
  //Detemine current variant ID to use
  let currentVariant;
  if(v) {
    currentVariant = v.id;
  } else if(p.first_available_variant.id) {
    currentVariant = p.first_available_variant.id;
  }

  // Check cart availability
  let inCart = getCountOfVariantInCart(currentVariant);
  let thumbnailStatus = '';
  if(available) {
    if(v.inventory_policy != 'continue' && v.inventory_management != null && (v.inventory_quantity - inCart) <= 0) {
      thumbnailStatus = 'all-in-cart';
    } else {
      thumbnailStatus = 'add';
    }
  } else {
    thumbnailStatus = 'sold-out';
  }

  // Create variable to decide whether we show variables or not
  let showOptions = p.variants.length == 1 || p.has_only_default_variant ? false : true;

  //Select Image to Display
  let img = p.image;
  let hasImg2 = false;
  let img2 = p.hover_image;
  if(img2) {
    hasImg2 = true;
  }

  if(v.featured_image && v.featured_image.src) img = v.featured_image.src;

  // Product Badge
  let handle = '';
  let label = '';
  for(let i = 0; i < p.tags.length; i++) {
    let tag = p.tags[i];
    let tagLow = tag.toLowerCase();
    if(tagLow === "incoming stock") {
      let languageString = Language.strings['products.product.incoming_stock_badge'];
      handle = handlize(languageString);
      label = languageString;
    } else if(tagLow.includes('badge')) {
      label = tagLow.split('_')[1];
      handle = handlize(label);
    }
  }

  // Setup preorder data
  let isPreorder = false;
  if(v.inventory_policy === 'continue' && v.inventory_management != null && (v.inventory_quantity - inCart) <= 0) {
    let languageString = Language.strings['products.product.preorder_badge'];
    isPreorder = true;
    handle = handlize(languageString);
    label = languageString;
  }

  // console.log(`isPreorder: ${isPreorder}`);

  // let productBadge = '';
  // if (label.length > 0) {
  //   productBadge = `<span class="o-badge o-badge--${handle}">${label}</span>`;
  // }

  // Visual Swatches
  let swatchesHtml = '';
  if(showOptions != false) {
    p.options_with_values.forEach((option) => {
      let optionHandle = handlize(option.name);

      if(optionHandle == 'size') {
        swatchesHtml += `
          <div class="o-swatches__swatch has-js is-size" data-swatch>
            <span class="o-swatches__swatch-header">
              <span class="o-swatches__swatch-header-name">
                ${option.name}
              </span>
            </span>

            <div class="o-swatches__swatch-options"
              data-swatch-options
              data-swatch-position="${option.position}"
              data-index="option${option.position}"
              data-swatch-option-name="${option.name}"
            >
        `;

        option.values.forEach((value) => {
          swatchesHtml += `
            <button
              type="button"
              class="o-swatches__swatch-option is-size
              ${option.selected_value == value ? 'is-selected' : ''}
              is-visible"
              data-swatch-object
              data-value="${escapeString(value)}"
              data-swatch-position="${option.position}"
              title="${escapeString(value)}"
            >
              <span class="o-swatches__swatch-option-label">${escapeString(value)}</span>
            </button>
          `;
        });

        swatchesHtml += `
            </div>
          </div>
        `;
      } else {
        if(option.values.length > 1) {
          swatchesHtml += `
            <div class="o-swatches__swatch has-js is-default" data-swatch>
              <p class="o-swatches__swatch-header">
                <span class="o-swatches__swatch-header-name">
                  ${option.name}
                </span>
                <span class="o-swatches__swatch-header-value"
                  data-swatch-value data-swatch-position="${option.position}"
                  data-index="option${option.position}"
                >
                  ${escapeString(option.selected_value).toLowerCase()}
                </span>
              </p>

              <div class="o-swatches__swatch-select-container">
                <select
                  class="o-swatches__swatch-select o-select"
                  data-index="${option.position}"
                  data-swatch-selector data-swatch-position="${option.position}"
                  data-swatch-option-name="${option.name}"
                >
          `;
          option.values.forEach((value) => {
            swatchesHtml += `
              <option
                value="${escapeString(value)}"
                ${option.selected_value == value ? 'selected="selected"' : ''}
              >
                ${escapeString(value).toLowerCase()}
              </option>
            `;
          });

          swatchesHtml += `
                </select>
              </div>
            </div>
          `;
        }
      }
    });
  }

  // Wishlist Button
  let wishlistButtonHtml = '';
  if(p) {
    wishlistButtonHtml += `
      <script class="swym-product-view-snippet">
      ['SwymViewProducts', 'SwymWatchProducts', 'SwymProductVariants'].forEach(function(k){
        if(!window[k]) window[k] = {};
      });
      (function(et){
        var collections = "${p.type}";
        var o={}, empi=${p.id},
        piu = "${getImageUrl(p.image, 620)}";
    `;

    p.variants.forEach((variant) => {
      wishlistButtonHtml+= `
        SwymProductVariants[${variant.id}] = {
          empi:empi,epi:${variant.id},
          du:"${window.Shop.url}${p.url}",
          dt:"${p.title}",
          ct: collections,
          iu: ${variant.featured_image ? `"${getImageUrl(variant.featured_image.src, 620)}"` : 'piu' },
          stk: ${variant.inventory_quantity},
          pr: ${variant.price}/100,
          ${variant.compare_at_price !== false ? `op: ${variant.compare_at_price}/100, ` : ''}
          variants: [{ "${variant.title}" : ${variant.id}}]
        };
        SwymWatchProducts[${variant.id}] = o[${variant.id}] = {"id": ${variant.id}, "available": ${variant.available},"inventory_management": "${variant.inventory_management}","inventory_quantity": ${variant.inventory_quantity},"title": "${variant.title}", "inventory_policy": "${variant.inventory_policy}"};
      `;
    });

    wishlistButtonHtml += `
          var product_data = {
            empi:empi, epi:${v.id},
            dt	:"${p.title}",du:"${window.Shop.url}${p.url}",
            ct 	:collections,pr:${v.price}/100,stk:${v.inventory_quantity},
            iu	:${v.featured_image ? `"${getImageUrl(v.featured_image.src, 620)}"` : 'piu' },variants:[{ "${v.title}" : ${v.id} }]
            ${v.compare_at_price !== false ? `,op:${v.compare_at_price}/100, ` : ''}
          };
          SwymViewProducts["${p.handle}"] = SwymViewProducts[${p.id}] = product_data;
          SwymWatchProducts["${p.handle}"] = SwymWatchProducts[${p.id}] = o;
        })();
      </script>
    `;

    wishlistButtonHtml += `
      <button class="${CP}__wishlist o-btn" data-swaction="addToWishlist" data-product-id="${p.id}">
        ${generateIcon('heart-white', `${CP}__wishlist-icon is-empty`)}
        ${generateIcon('heart-white-filled', `${CP}__wishlist-icon is-full`)}
      </button>
    `;
  }

  return `
    <div
      class="${CP} js-print c-collection-template__product"
      data-product-thumbnail data-product-handle="${p.handle}"
      data-product-id="${p.id}" data-variant-id="${currentVariant}"
      data-product-qty="${v.inventory_quantity}"
      itemprop="itemListElement" itemscope itemtype="http://schema.org/Product"
    >
      <div class="${CP}__container c-collection-template__product__container">
        <script type="application/json" data-product-thumbnail-json>
          ${JSON.stringify(p2)}
        </script>
        <script type="application/json" class="bold-product-json">
          ${JSON.stringify(p2)}
        </script>

        <a href="${p.url}" class="${CP}__image-container">
          <div data-product-thumbnail-image-first>
            ${generatePicture(img, 600, [600], `${CP}__image__img-first`, '', 'itemprop="image"' )}
          </div>

          ${hasImg2 == true ? `
            ${generatePicture(img2, 600, [600], `${CP}__image__img-hover`, '', 'itemprop="image"' )}
          ` : ''}

          ${productBadge != '' ? productBadge : ''}
        </a>

        <div
          class="${CP}__details--wrapper"
          ${p.has_only_default_variant ? 'has-options' : ''}
          data-product-thumbnail-content
        >
          <form
            data-product-form
            method="POST"
            action="/cart/add"
            enctype="multipart/form-data"
            class="${CP}__form"
          >
            <input type="hidden" name="id" value="${currentVariant}" data-product-thumbnail-input />

            <div class="${CP}__details" data-product-thumbnail-url>
              <div class="${CP}__details-option" data-product-thumbnail-option>
                ${swatchesHtml != '' ? `
                  <div class="o-swatches" data-swatches>
                    ${swatchesHtml}
                  </div>
                ` : ''}
              </div>

              <div class="${CP}__details-titles">
                <h5 itemprop="name" class="${CP}__title is-size-6">
                  <a href="${p.url}" title="${escapeString(p.title)}">
                    ${escapeString(p.title)}
                  </a>
                </h5>

                ${p.price > 0 ? `
                  <div class="${CP}__details-pricing" data-product-thumbnail-pricing>
                    ${p.price_min && p.variants.size > 1 ? `
                      <span class="o-product-pricing__price-form o-product-pricing__money o-product-pricing__price o-product-pricing__pricing">
                        ${Language.strings['products.general.from']}
                      </span>

                      <span
                        data-currency
                        data-money="${p.price_min}"
                        class=" o-product-pricing__price-form o-product-pricing__money o-product-pricing__price o-product-pricing__pricing"
                      >
                        <span class="money" data-product-id="${p.id}">${printMoney(p.price_min)}</span>
                      </span>
                    `: `
                      ${generatePricing(v.price, compare, CP, p)}
                    `}
                  </div>
                ` : ''}
              </div>
            </div>

            <div class="${CP}__bottom ${showOptions ? 'has-options' : ''}" data-product-thumbnail-button>
              <div class="${CP}__bottom-btns" data-product-thumbnail-btns>
                ${showOptions ? `
                  <button class="${CP}__options o-btn" data-product-show-options>
                    ${p.options_with_values.reduce((x, option) => {
                      x += `<span class="${CP}__options-label">
                        ${handlize(option.name)}
                      </span>`;
                      return x;
                    }, '')}

                    ${generateIcon('plus-white')}
                  </button>
                ` : ''}

                <div class="${CP}__addcart" data-product-thumbnail-button>
                  ${(available && showOptions && !p.options.includes('Size')) || p.price <= 0 ? `
                    <a href="${p.url}" class="o-product-thumbnail__addcart-btn o-add-cart-btn o-btn">
                      ${Language.strings['products.general.view_product']}
                    </a>
                  ` : `
                    <button
                      class="${CP}__addcart-btn o-add-cart-btn o-btn
                      ${available != true ? 'is-not-available' : ''}"
                      ${available != true ? 'disabled' : ''}
                      title="${available ? `
                        ${
                          thumbnailStatus == 'all-in-cart' ?
                          Language.strings['products.product.all_in_cart'] :
                          `${isPreorder ? Language.strings['products.product.on_preorder'] : Language.strings['products.general.add_to_cart_button']}`
                        }
                      ` : `
                        ${Language.strings['products.general.not_available']}
                      `}"
                      data-product-thumbnail-addcart
                      ${!available || thumbnailStatus == 'all-in-cart' ?
                        'disabled': ''
                      }
                    >
                      <div class="${CP}__addcart-btn__available">
                        <span
                          class="o-product-thumbnail__addcart-btn__label"
                          data-product-thumbnail-addcart-label
                        >
                          ${available == true ? `
                            ${thumbnailStatus == 'all-in-cart' ?
                              Language.strings['products.product.all_in_cart'] : ''
                            }
                            ${thumbnailStatus == 'add' ?
                              isPreorder ? Language.strings['products.product.on_preorder'] : Language.strings['products.general.add_to_cart_button']
                            : ''}
                          ` : `
                            ${Language.strings['products.product.sold_out']}
                          `}
                        </span>
                        ${generateIcon('plus-white')}
                      </div>

                      <div class="${CP}__addcart-btn__disable">
                        ${Language.strings['products.general.not_available']}
                      </div>
                    </button>
                  `}
                </div>
              </div>

              ${wishlistButtonHtml}
            </div>

          </form>

        </div>
      </div>
    </div>
  `;
};
